// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --pill-font-size: 0.75em;
  --pill-font-weight: 500;
  --pill-border-radius: 8px;
  --pill-padding: 0.25em 0.5em;
  --pill-children-space-between: 0.4em;

  --pill-light-background: white;
  --pill-light-color: black;
  --pill-grey-background: var(--color-grey-4);
  --pill-grey-color: white;
  --pill-dark-background: var(--color-grey-7);
  --pill-dark-color: white;
  --pill-info-background: var(--color-blue-1);
  --pill-info-color: white;
  --pill-success-background: var(--color-green-1);
  --pill-success-color: white;
  --pill-warn-background: var(--color-yellow-1);
  --pill-warn-color: black;
  --pill-error-background: var(--color-red-2);
  --pill-error-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Pill.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;;EAEpC,8BAA8B;EAC9B,yBAAyB;EACzB,2CAA2C;EAC3C,wBAAwB;EACxB,2CAA2C;EAC3C,wBAAwB;EACxB,2CAA2C;EAC3C,wBAAwB;EACxB,+CAA+C;EAC/C,2BAA2B;EAC3B,6CAA6C;EAC7C,wBAAwB;EACxB,2CAA2C;EAC3C,yBAAyB;AAC3B","sourcesContent":[".commutably {\n  --pill-font-size: 0.75em;\n  --pill-font-weight: 500;\n  --pill-border-radius: 8px;\n  --pill-padding: 0.25em 0.5em;\n  --pill-children-space-between: 0.4em;\n\n  --pill-light-background: white;\n  --pill-light-color: black;\n  --pill-grey-background: var(--color-grey-4);\n  --pill-grey-color: white;\n  --pill-dark-background: var(--color-grey-7);\n  --pill-dark-color: white;\n  --pill-info-background: var(--color-blue-1);\n  --pill-info-color: white;\n  --pill-success-background: var(--color-green-1);\n  --pill-success-color: white;\n  --pill-warn-background: var(--color-yellow-1);\n  --pill-warn-color: black;\n  --pill-error-background: var(--color-red-2);\n  --pill-error-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
